package com.pincer.core.rules

import com.pincer.core.functions.validateId
import com.pincer.core.InvalidData
import com.pincer.core.model.tree.Candidate
import com.pincer.core.model.tree.Attendance

class ParticipantRule(val principalId: String): Rule() {

    override fun score(candidate: Candidate): Float {
        when (candidate.attendance(principalId)) {
            Attendance.ATTENDING     -> return DEFINITELY_POSSIBLE
            Attendance.UNKNOWN       -> return MIGHT_BE_POSSIBLE
            Attendance.NOT_ATTENDING -> return DEFINITELY_NOT_POSSIBLE
        }
    }

    companion object {
        fun parse(params: List<String>): ParticipantRule {
            if (params.size != 1) throw InvalidData("The participant rule needs exactly one parameter")
            val build = ParticipantRule(params.first())
            if (validateId(build.principalId) != null) throw InvalidData("There's something wrong with the principalId in the paricipant rule")
            return build
        }
    }

}

